import VALIDATION_OPTIONS from "../constants/validationOptions"

const doValidate = (dataSchema, data) => dataSchema.validate(
    data, 
    VALIDATION_OPTIONS
)

export default doValidate